module.exports = __webpack_public_path__ + "static/media/ipad_pro_mockup.67959734.png";